import { Component, Input, ViewChild, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import * as L from 'leaflet';
import * as D3 from "d3";

@Component({
  selector: 'app-map-control',
  templateUrl: './map-control.component.html',
  styleUrls: ['./map-control.component.scss']
})
export class MapControlComponent implements AfterViewInit {
  @Input() sedes: any = {};
  @Input() fullData: any = [];
  @ViewChild("chart") element: ElementRef;

  private host: any;
  private svg;
  private htmlElement: HTMLElement;

  public isOpen: any = false;
  public loading: any = true;
  public contId: any;
  public countMujer: any = 0;
  public countHombre: any = 0;
  public totalEmpleados: any;
  public groupByAlcaldia: any;
  public payload: any = [];
  public sueldo_promedio: any;
  public promedio_city: any;
  public hidden: any = false;
  public g: any;
  public navCtrlr: any = [
    { id: 0, title: "Grafícas", src_img: "assets/images/icon-cdmx-chart.svg", active: false },
    { id: 1, title: "Mapa", src_img: "assets/images/icon-cdmx-map.svg", active: false },
    { id: 2, title: "Información", src_img: "assets/images/icon-cdmx-info.svg", active: true }
  ];

  public selectedGroup: any = {
    count_m: 0,
    count_h: 0,
    avg_salario: 0
  };

  constructor() { }

  ngAfterViewInit(): void {}

  public toggleControl (item) {
    this.navCtrlr.map(el => this.navCtrlr[el.id].active = false);
    this.navCtrlr[item.id].active = true;

    if (item.id == 1) {
      this.drawBars(this.fullData, "");
    }
  }

  public toggleView(event: any): void {
    this.isOpen = this.isOpen ? false : true;
  }

  public async ngOnChanges(changes: SimpleChanges) {
    if (changes.sedes.currentValue.message) {
      let arr = this.sedes.filters;

      console.log("ARR ==> ", arr);

      this.host = D3.select(this.htmlElement);
      this.groupByAlcaldia = [...new Set(this.sedes.filters.map(item => item.nombre))];

      await this.groupByAlcaldia.map(async (item) => {
        this.fullData.push(await this.processData(item));
      });

      this.loading = false;
    }
  }

  private async processData(data: any) {
    let controller = this;
    let alcaldia: any = data == "CDMX" ? this.sedes.filters : this.sedes.filters.filter(item => item.nombre == data);
    let avg_item: number = 0;
    let avg_m: number = 0;
    let avg_h: number = 0;
    let total: number = 0;
    let total_m: number = 0;
    let total_h: number = 0;
    let gnl_avg: number = 0;
    let avg_t_m: number = 0;
    let avg_t_h: number = 0;
    let geo_point: any = "";

    alcaldia.map(item => {
      avg_item += item.numero * item.promedio_sueldo_tabular_bruto;
      total += item.numero;

      if (item.sexo == 'Mujer') {
        avg_m += item.numero * item.promedio_sueldo_tabular_bruto;
        total_m += item.numero;
      } else if (item.sexo == "Hombre") {
        avg_h += item.numero * item.promedio_sueldo_tabular_bruto;
        total_h += item.numero;
      }
      geo_point = item.geo_point_2d;
    });

    gnl_avg = avg_item / total;
    avg_t_m = avg_m / total_m;
    avg_t_h = avg_h / total_h;

    return {
      name: data,
      value: gnl_avg.toFixed(2),
      gnl_avg: gnl_avg.toFixed(2),
      avg_t_m: avg_t_m.toFixed(2),
      avg_t_h: avg_t_h.toFixed(2),
      total: total,
      total_m: total_m,
      total_h: total_h,
      geo_point: geo_point
    };
  }

  public async loadSegment (event: any, alcaldia: any, index: any) {
    let segment = this.fullData.filter(el => el.name == alcaldia);
    let lsC = document.getElementsByClassName("info-block");

    for(let i = 0; i < lsC.length; i++) { lsC[i].classList.add("hidden"); }
    document.getElementById(`alcaldia-${index}`).classList.remove("hidden");

    this.contId = index;
    this.selectedGroup.count_m = segment[0].avg_t_m;
    this.selectedGroup.count_h = segment[0].avg_t_h;
    this.selectedGroup.avg_salario = segment[0].gnl_avg;
    this.selectedGroup.total_m = segment[0].total_m;
    this.selectedGroup.total_h = segment[0].total_h;
    this.selectedGroup.total = segment[0].total;

    let payload = [
      { sexo: "Mujer", numero: segment[0].avg_t_m },
      { sexo: "Hombre", numero: segment[0].avg_t_h }
    ];

    this.buildPie(payload);
  }

  private drawBars(datos: any[], options): void {
    const controller = this;
    const margin = { top: 10, right: 0, bottom: 50, left: 40 };
    const svgWidth = 320;
    const svgHeight = 840;
    const width = svgWidth - margin.left - margin.right;
    const height = svgHeight - margin.top - margin.bottom;

    this.host = D3.select("#hozChart");
    this.host.html("");

    let opts = {
      style: {
        stroke: "#244238",
        fill: "#89BE4A"
      },
      style_mouseover:{
        fill: "#244238"
      },
      data: {}
    }

    console.log("datos ==> ", datos)

    let data = datos.sort((a, b) => D3.ascending(a.name, b.name));
    let svg = this.host.append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    let x = D3.scaleLinear()
      .range([0, width])
      .domain([0, D3.max(data, (d) => d.value )]);

    let y = D3.scaleBand()
      .domain(data.map((d) => d.name))
      .range([0, 600])
      .padding(0.1);

    //make y axis to show bar names
    let yAxis = D3.axisLeft(y)
      .scale(y)
        //no tick marks
      //  .tickSize(0)
        // .orient("left");

    // console.log("yAxis => ", yAxis)

    // var gy = svg.append("g")
      // .attr("class", "y axis")
      // .call(yAxis)

    var bars = svg.selectAll(".bar")
      .data(data)
      .enter()
      .append("g")

    /*let tooltip = D3.select("body")
      .append("div")
      .style("position", "absolute")
      .style("z-index", "10")
      .style("visibility", "hidden")
      .style("background", "#000")
      .text("a simple tooltip");*/

    /*2827:'#a6e61c'
    4500:'#91d400'
    6000:'#00843d'
    9000:'#1a6334'
    10532:'#0f4c42'*/

    bars.append("rect")
      .attr("class", "bar")
      .attr("y", (d) => y(d.name))
      .attr("height", y.bandwidth())
      .attr("x", 0)
      .attr("width", (d) => x(d.value))
      .attr("fill", opts.style.fill)
      .attr("rx", 6)
      .on("mouseout", function() {
        D3.select(this).attr("fill", opts.style.fill);
      })
      .on("mouseover", function(d, i) {
        // let datos = controller.processData(controller.sedes);
        // controller.fullData.filter(el => el.name == d.name)
        let el = this.getBoundingClientRect();
        let offset = el.top - 80;

        console.log("D ==> ", d)

        return D3.select("body")
          .append("div")
          .style("position", "fixed")
          .style("background", "#fff")
          .style("box-shadow", "1px 1px 14px rgba(0,0,0,0.24)")
          .style("border-radius", "6px")
          .style("padding", "8px")
          .style("color", "#000")
          .style("width", "200px")
          .style("height", "260px")
          .style("opacity", 1)
          .style("z-index", 9999)
          // .style("top", `${offset}px`)
          .style("left", "60%")
          .attr("class", "tooltip")
          .attr("id", `tool-${i}`)
          .html(`
            <h4>${d.name}</h4>
            <h5>Empleados totales</h5>
            <p class="mb-0" style="font-size: 13px !important;">Mujeres: ${d.total_m}</p>
            <p class="mb-0" style="font-size: 13px !important;">Hombres: ${d.total_h}</p>
            <h5>Salarios promedio</h5>
            <p class="mb-0" style="font-size: 13px !important;">Mujeres: $${d.avg_t_m}</p>
            <p class="mb-0" style="font-size: 13px !important;">Hombres: $${d.avg_t_h}</p>
          `)
          .style("visibility", "visible");
      }).on("mouseout", function (d, i) {
        D3.select(`#tool-${i}`).remove();
      });

    bars.append("text")
      .attr("class", "label")
      .attr("y", (d) => {
        return y(d.name) + y.bandwidth() / 2 + 4;
      })
      .attr("x", (d) => {
        return 10;
      })
      .text(d => { return `${d.name} - $${d.value}`});
  }

  public async selectAlcaldia (event) {
    this.countMujer = 0;
    this.countHombre = 0;

    let alcaldias = event.target.value == "CDMX" ? this.sedes.filters : this.sedes.filters.filter(el => el.nombre == event.target.value);
    let mujeres = alcaldias.filter(el => el.sexo == "Mujer");
    let hombres = alcaldias.filter(el => el.sexo == "Hombre");

    await mujeres.map(item => this.countMujer += item.numero );
    await hombres.map(item => this.countHombre += item.numero );

    this.payload = [];

    this.payload.push({ sexo: "Hombre", numero: this.countHombre })
    this.payload.push({ sexo: "Mujer", numero: this.countMujer })

    let sueldo = await alcaldias.reduce((a, b) => ({promedio_sueldo_tabular_bruto: a.promedio_sueldo_tabular_bruto + b.promedio_sueldo_tabular_bruto }) )
    this.sueldo_promedio = sueldo.promedio_sueldo_tabular_bruto / alcaldias.length;

    let sueldos = [];
    sueldos.push({ alcaldia: "CDMX", total: this.promedio_city});
    sueldos.push({ alcaldia: event.target.value, total: this.sueldo_promedio});

    this.drawBars(sueldos, "");
  }

  public async buildPie (payload: any) {
    let w = 500;
    let h = 300;
    let r = Math.min(w, h)/2;
    let labelr = r + 30; // radius for label anchor
    let color = D3.scaleOrdinal().domain(payload).range(["#244238", "#89BE4A"]);
    let donut = D3.pie();

    // console.log("DATA !!!!! ", payload);

    this.host = D3.select(`#pie-container-${this.contId}`);
    this.host.html("");

    this.svg = this.host.append("svg")
      .attr("viewBox", `-80 0 ${w} ${h}`)
      .append("g")
      .attr("transform", `translate(${r}, ${r})`);

    let pie = D3.pie()
      .value((d: any) => { return d.numero });

    let arcSelection = this.svg.selectAll(".arc")
      .data(pie(payload))
      .enter()
      .append("g")
      .attr("class", "arc");

    let pieColor = D3.scaleOrdinal()

    let arc = D3.arc()
      .innerRadius(r*.6)
      .outerRadius(r);

    arcSelection.append("path")
      .attr("fill", (d: any, i: string) => { return color(i) })
      .attr("d", arc)

    arcSelection.append("text")
      .attr("text-anchor", "middle")
      .attr('x', function (d: any) {
        var a = d.startAngle + (d.endAngle - d.startAngle)/2 - Math.PI/2;
        d.cx = Math.cos(a) * (r - 45);
        return d.x = Math.cos(a) * (r+30);
      })
      .attr("y", function(d: any) {
        var a = d.startAngle + (d.endAngle - d.startAngle)/2 - Math.PI/2;
        d.cy = Math.sin(a) * (r - 45);
        return d.y = Math.sin(a) * (r + 30);
      })
      .text((datum, index) => payload[index].sexo)
      .each(function(d: any) {
        var bbox = this.getBBox();
        d.sx = d.x - bbox.width/2 - 2;
        d.ox = d.x + bbox.width/2 + 2;
        d.sy = d.oy = d.y + 18;
      });

    arcSelection.append("path")
      .attr("class", "pointer")
      .style("fill", "none")
      .style("stroke", "#666")
      .attr("d", function(d: any) {
        return d.cx > d.ox ? `M${d.sx},${d.sy}L${d.ox},${d.oy} ${d.cx},${d.cy}` : `M${d.ox},${d.oy}L${d.sx},${d.sy} ${d.cx},${d.cy}`;
      });
  }
}
